import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable({
  providedIn: "root",
})
export class LoaderService {

  loader$: Subject<boolean> = new Subject();

  public show() {
    this.loader$.next(true);
  }
  public hide() {
    this.loader$.next(false);
  }
}
